import SalesVelocityHeatmapMap from '../SalesVelocityWrapper/SalesVelocityHeatmapMap'

export default function AttendanceIntelligenceHeatmapMap({ heatmap }) {
  if (heatmap?.error === 'seatmap_not_found') {
    return (
      <p className="text-muted small mb-0">
        No seatmap is configured for this event. Section-level scan rates are
        still available in the segment breakdown.
      </p>
    )
  }

  if (!heatmap?.seatmap?.mapping) {
    return (
      <p className="text-muted small mb-0">
        Seatmap data is not available for this event.
      </p>
    )
  }

  return (
    <>
      <SalesVelocityHeatmapMap
        mapping={heatmap.seatmap.mapping}
        background={heatmap.seatmap.background}
        seatBorderRadius={heatmap.seatmap.seatBorderRadius}
        venue={heatmap.venue}
        bySeatKey={heatmap.bySeatKey}
        metricId="attendance"
        metricRanges={{ attendance: heatmap.metricRanges }}
      />
      <div className="attendance-intelligence-gradient-legend" aria-hidden>
        <span>Low</span>
        <div className="attendance-intelligence-gradient-bar" />
        <span>High</span>
      </div>
    </>
  )
}
